import { Retailer } from '@/core/entity';
import { IFileGateway, IRetailerGateway, PresenterFunc, UpdaterFunc } from '@/core/interface';

export class CreateRetailer {
  constructor(
    private readonly fileGateway: IFileGateway,
    private readonly retailerGateway: IRetailerGateway,
  ) { }

  public async execute(
    name: string,
    country: string,
    desId: string,
    file: File,
    presenter: PresenterFunc<Retailer | null>,
    updater?: UpdaterFunc,
  ) {
    presenter(null, null, true);

    try {
      const uploadItem = await this.retailerGateway.getRetailerLogoUploadUrl(file.type);

      await this.fileGateway.upload(file, uploadItem.uploadUrl);

      const result = await this.retailerGateway.createRetailer({
        id: '',
        name,
        logo: uploadItem.fileUri,
        country,
        desId,
      }, undefined, updater);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
